"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullHeightCard = exports.StaticHeightCard = exports.FullHeightVerticalStack = exports.ErrorBody = exports.ErrorText = exports.ErrorTitle = exports.ErrorBlock = exports.SaveButton = exports.PageHeader = exports.Row = exports.StyledDomainsConfigurationContent = exports.FullPageContent = exports.ScrollingContent = exports.Page = exports.SubHeader = exports.Header = exports.EmptyBlock = exports.NoDomainsText = exports.NoSearchResultBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
exports.NoSearchResultBlock = styled_components_1.default.div `
  padding: ${(0, alchemy_ui_1.units)(7)};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.NoDomainsText = styled_components_1.default.h3 `
  color: #2C3548;
  font-size: ${(0, alchemy_ui_1.units)(2.5)};
  font-weight: bold;
  padding-top: ${(0, alchemy_ui_1.units)(2.2)};
`;
exports.EmptyBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
exports.Header = styled_components_1.default.h3 `
  font-size: ${(0, alchemy_ui_1.units)(2.5)};
  font-weight: bold;
  line-height: ${(0, alchemy_ui_1.units)(3)};
  color: #1B2437;
  margin-top: ${(0, alchemy_ui_1.units)(5)};
`;
exports.SubHeader = styled_components_1.default.h5 `
  font-size: ${(0, alchemy_ui_1.units)(1.5)};
  color: #2C3548;
`;
exports.Page = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - 58px);
`;
exports.ScrollingContent = styled_components_1.default.div `
  height: 100%;
  overflow-y: auto;
`;
exports.FullPageContent = styled_components_1.default.div `
  height: 100%;
  min-height: 580px;
  display: flex;
`;
exports.StyledDomainsConfigurationContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`;
exports.Row = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid rgb(200, 199, 204);
  padding: 0px 0 0px ${(0, alchemy_ui_1.units)(3)};
  align-items: center;
  height: 50px;
`;
exports.PageHeader = styled_components_1.default.h2 `
  font-size: 22px;
  font-weight: 400;
  line-height: ${(0, alchemy_ui_1.units)(4)};
  color: rgb(142, 142, 147);
`;
exports.SaveButton = styled_components_1.default.button `
  border: none;
  background: transparent;
  padding: ${(0, alchemy_ui_1.units)(2)};
  border-left: 1px solid #c8c7cc;
  color: #5081ff;
  & i {
    margin-right: ${(0, alchemy_ui_1.units)(1.25)};
  }
  opacity: ${(props) => props.disabled ? '0.6' : '1'};
`;
exports.ErrorBlock = styled_components_1.default.div `
  display: flex;
  font-size: 30px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
exports.ErrorTitle = styled_components_1.default.h4 `
  font-weight: bold;
  color: #2C3548;
  font-size: 20px;
  line-height: 24px;
  margin-top: ${(0, alchemy_ui_1.units)(3)};
  margin-bottom: ${(0, alchemy_ui_1.units)(1)};
`;
exports.ErrorText = styled_components_1.default.h4 `
  color: #2C3548;
  font-size: 16px;
  line-height: 22px;
`;
exports.ErrorBody = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.FullHeightVerticalStack = (0, styled_components_1.default)(VerticalStack_1.default) `
  flex: 1;
  padding: ${(0, alchemy_ui_1.units)(3)};
`;
exports.StaticHeightCard = (0, styled_components_1.default)(alchemy_ui_1.Card) `
  flex: 0 0 auto;
`;
exports.FullHeightCard = (0, styled_components_1.default)(alchemy_ui_1.Card) `
  flex: 1 0 auto;
`;
